import 'jquery.inputmask/dist/jquery.inputmask.bundle';


import 'Inputmask.mod/dates';


export default window.Inputmask;
delete window.Inputmask;
